<template>
  <v-card class="pa-1" flat color="#f0f0f0" style="border-radius: 0px">
    <v-container v-if="aData">
      <v-card class="cshadow">
        <v-row>
          <v-col cols="2" class="pa-1 pl-4 pb-0">
            <img
              alt=""
              :src="getImgPath(aData.picHeadShot)"
              style="border-radius: 3px; height: 90px"
            />
          </v-col>
          <v-col cols="5" class="pa-1">
            <div style="font-size: 1.2rem; font-weight: 600">
              <div>App No : {{ aData.app_id }}</div>
              {{ aData.fName }} {{ aData.lName }}
            </div>
          </v-col>
          <v-col cols="5" class="pa-1">
            <div style="font-size: 1.2rem; font-weight: 600">
              <div style="color: #808080; font-size: 1rem">App Status</div>
              {{ aData.status_named }}
            </div>
            {{ aData.reason_name }}
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12">
          <v-card class="cshadow">
            <div class="cardHeader">Personal Details</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="4">
                  <FieldValue
                    Text="First Name"
                    :Value="aData.fName"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Last Name"
                    :Value="aData.lName"
                  ></FieldValue>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <FieldValue
                    Text="Father/Guardian Name"
                    :Value="aData.fatherName"
                  ></FieldValue>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="4">
                  <FieldValue Text="Gender" :Value="aData.gender"></FieldValue>
                </v-col>                
                <v-col cols="5">
                  <FieldValue Text="Email" :Value="aData.email"></FieldValue>
                </v-col>
                <v-col cols="3">
                  <FieldValue
                    Text="Mobile"
                    :Value="aData.ext + ' - ' + aData.mobile"
                  ></FieldValue>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-card class="cshadow mt-3">
            <div class="cardHeader">Address</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="4">
                  <FieldValue
                    Text="Line 1"
                    :Value="aData.addLine1"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Line 1"
                    :Value="aData.addLine2"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue Text="City" :Value="aData.city"></FieldValue>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="3">
                  <FieldValue Text="State" :Value="aData.state"></FieldValue>
                </v-col>
                <v-col cols="3">
                  <FieldValue
                    Text="Country"
                    :Value="aData.country"
                  ></FieldValue>
                </v-col>
                <v-col cols="3">
                  <FieldValue
                    Text="Pin Code"
                    :Value="aData.pinCode"
                  ></FieldValue>
                </v-col>
                <v-col cols="3">
                  <FieldValue
                    Text="Nationality"
                    :Value="aData.nationality"
                  ></FieldValue>
                </v-col>
              </v-row>
            </div>
          </v-card>
          
          <v-card class="cshadow mt-3">
            <div class="cardHeader">Accreditation Details</div>
            <div class="pa-3 pt-0">
              <v-row>
                <v-col cols="4">
                  <FieldValue
                    Text="Company Type"
                    :Value="aData.companytype_name"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Job Type"
                    :Value="aData.jobtype_name"
                  ></FieldValue>
                </v-col>
                <v-col cols="4">
                  <FieldValue
                    Text="Access"
                    :Value="aData.print_text"
                  ></FieldValue>
                </v-col>
                <!-- <v-col cols="4" v-if="aData.preferedCityName">
                  <FieldValue
                    Text="Prefered City For Card Pickup"
                    :Value="aData.preferedCityName"
                  ></FieldValue>
                </v-col> -->
              </v-row>
            </div>
          </v-card>              
        </v-col>
        
      </v-row>
    </v-container>
   
    <v-overlay :value="loading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import "viewerjs/dist/viewer.css";
import FieldValue from "../application/FieldValue";

export default {
  name: "ViewAppliation",
  components: { FieldValue },
  props: ["aData"],
  data: () => ({
    loading: false,
    modPdf: false,
  }),
  methods: {
    getImgPath(fileName) {
      if (fileName == "" || fileName == null) {
        return "images/nophoto.png";
      } else {
        return this.$apiPhotoPath + "/" + fileName;
      }
    },
  },
};
</script>

<style scoped>
.imgId {
  border-radius: 7px;
  box-shadow: 0 0 10px #ccc;
  cursor: pointer;
}
.cshadow {
  box-shadow: 0 0 15px #e7e7e7 !important;
}
</style>